import { useCallback } from 'react';
import { API_BASE } from '@platform/dao';
import { routes } from '@platform/core/lib/routes';
import { useAuthSsoMutation } from '@platform/features/auth';
import type { IAuthOptions, SsoProvider } from '@platform/features/auth';
import { postForm } from './postForm';
import { useEnterApp } from './useEnterApp';

/**
 * Вхід кнопками «Продовжити з Google / Microsoft»: у Development сервер одразу відкриває сесію демо-облікового запису (як sso() прототипу) —
 * далі останній або перший простір; у продуктиві — POST-форма на /auth/sso/{provider}, сервер переадресовує до OIDC-постачальника.
 */
export function useSsoSignIn(options: IAuthOptions | undefined, onError: (code: string) => void): (provider: SsoProvider) => void {
  const [sso] = useAuthSsoMutation();
  const enter = useEnterApp();
  return useCallback((provider: SsoProvider) => {
    if (options?.mode === 'prod') { postForm(`${API_BASE}/auth/sso/${provider}`); return; }
    sso({ provider, demoEmail: options?.demoEmail }).unwrap().then(() => enter(routes.root()), (e: { code?: string }) => onError(e.code ?? ''));
  }, [options, sso, enter, onError]);
}
